import { useMutation } from "@tanstack/react-query";
import { BookingService } from "@/services/BookingService";
import type { CanMoveRequest, CanMoveValidationResponse } from "@/types/CanMoveValidation";

/**
 * Hook to check if a booking can be moved to a new date/time
 * Uses React Query's useMutation for proper loading/error states
 */
export function useCanMoveBooking() {
  const bookingService = new BookingService();

  return useMutation<CanMoveValidationResponse, Error, CanMoveRequest>({
    mutationFn: async (params: CanMoveRequest) => {
      return await bookingService.checkCanMove(params);
    },
  });
}
